import { notification } from "antd";

const mapKey = process.env.REACT_APP_GOOGLE_MAP_API

const ReverseGeocoding = async (coordinates) => {
    const { lat, lng } = coordinates;
    try {
        const resp = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${mapKey}`);
        if (!resp.ok) {
            throw new Error(`HTTP error! Status: ${resp.status}`)
        }
        const data = await resp.json();
        if (data.results && data.results.length > 0) {
            const { formatted_address, geometry: { location: { lat, lng } } } = data.results[0];
            const geoCoordinates = { lat, lng };

            let city, country, town, postalCode;
            const locationDetails = data?.results.find(result => result.types.includes('locality'));
            if (locationDetails) {
                postalCode = locationDetails.address_components.find(component => component.types.includes('postal_code')) && 
                locationDetails.address_components.find(component => component.types.includes('postal_code')).long_name;

                town = locationDetails.address_components.find(component => component.types.includes('sublocality')) && 
                locationDetails.address_components.find(component => component.types.includes('sublocality')).long_name;

                city = locationDetails.address_components.find(component => component.types.includes('locality')) && 
                locationDetails.address_components.find(component => component.types.includes('locality')).long_name;

                country = locationDetails.address_components.find(component => component.types.includes('country')) && 
                locationDetails.address_components.find(component => component.types.includes('country')).long_name;
            } else {
                console.log('City not found');
            }
            return { formatted_address, geoCoordinates, city, country, town, postalCode }
        }
        return
    }
    catch (error) {
        notification.warning({message: 'Error while fetching current address'})
        console.log(error)
    }
}

export default ReverseGeocoding